import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

type TInsightsIcon = {
    className?: string;
    fill?: string;
    width?: string;
    height?: string;
};

export const InsightsIcon = ({ className, fill = "#AD50CE", width = "25", height = "25" }: TInsightsIcon) => {
    return (
        <SvgIcon
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.96922 1.7538L9.59879 4.23218C9.86957 5.29812 10.7019 6.13044 11.7678 6.40121L14.2462 7.03079C15.2265 7.27981 15.2265 8.72019 14.2462 8.96922L11.7678 9.59879C10.7019 9.86957 9.86957 10.7019 9.59879 11.7678L8.96922 14.2462C8.72019 15.2265 7.27981 15.2265 7.03079 14.2462L6.40121 11.7678C6.13044 10.7019 5.29812 9.86957 4.23218 9.59879L1.7538 8.96922C0.773474 8.72019 0.773474 7.27981 1.7538 7.03079L4.23218 6.40121C5.29812 6.13044 6.13044 5.29812 6.40121 4.23218L7.03079 1.7538C7.27981 0.773474 8.72019 0.773474 8.96922 1.7538Z"
                fill={fill}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.4692 10.7538L15.5924 11.2386C15.8631 12.3045 16.6955 13.1369 17.7614 13.4076L18.2462 13.5308C19.2265 13.7798 19.2265 15.2202 18.2462 15.4692L17.7614 15.5924C16.6955 15.8631 15.8631 16.6955 15.5924 17.7614L15.4692 18.2462C15.2202 19.2265 13.7798 19.2265 13.5308 18.2462L13.4076 17.7614C13.1369 16.6955 12.3045 15.8631 11.2386 15.5924L10.7538 15.4692C9.77347 15.2202 9.77347 13.7798 10.7538 13.5308L11.2386 13.4076C12.3045 13.1369 13.1369 12.3045 13.4076 11.2386L13.5308 10.7538C13.7798 9.77347 15.2202 9.77347 15.4692 10.7538Z"
                fill={fill}
            />
        </SvgIcon>
    );
};
